/* tslint:disable */
export enum ShiftType {
    Morning = 1,
    Afternoon = 2,
    Night = 3,
    Weekend = 4,
    Unset = 5,
}